import { useEffect, useReducer } from 'react';
import { applyPatch } from 'fast-json-patch';
import useEvents from './Events';
import useFetch from './Fetch';


export default function useStateTracker({event, url, query=null, reload=false}) {
  const initialState = { result: {}, pageCount: 1 }
  const eventEmitter = useEvents()
  const { status, data, error, refresh } = useFetch(url, query)
  const [ state, dispatch ] = useReducer((state, action) => {
    switch (action.type) {
      case 'SET':
        const r = action.payload.result.reduce((map, obj) => {map[obj.id] = obj; return map}, {})
        return { result: r, pageCount: action.payload.page_count }
      case 'UPDATE':
        try {
          const p = applyPatch(state.result, action.payload, false, false).newDocument
          return { result: p, pageCount: state.pageCount }
        }
        catch (e) {
          return state
        }
      default:
        return state
    }
  }, initialState)

  useEffect(() => {
    if (data.result) {
      dispatch({type: 'SET', payload: data})
    }
  }, [data])

  useEffect(() => {
    if (eventEmitter.event) {
      for (const event of eventEmitter.event) {
        if (reload && (event.type ==='Created' || event.type === 'Deleted'))
          refresh()
        dispatch({type: 'UPDATE', payload: event.data})
      }
    }
  }, [eventEmitter.event])

  return { status, error, items: Object.values(state.result), pageCount: state.pageCount, dispatch }
}